import { WealthicaStorage } from '../../utils/storage';
import { logger } from '@/services/LoggingService';
import { NAVIGATION_STORAGE_KEYS } from './types';

/**
 * Clear all navigation data with CSRF-aware guard for OAuth callbacks.
 */
export function clearAllNavigationData(): void {
  const isCallback = window.location.pathname.includes('/investments/connect') &&
                    (window.location.search.includes('state=') || window.location.hash.includes('state='));

  if (isCallback) {
    logger.warn('Wealthica2NavigationProvider', '[CSRF-PROTECTION] Preventing navigation data clear during OAuth callback', {
      pathname: window.location.pathname,
      search: window.location.search,
      hash: window.location.hash,
      timestamp: new Date().toISOString()
    });
    return;
  }

  const keysToRemove = [
    NAVIGATION_STORAGE_KEYS.STATE,
    NAVIGATION_STORAGE_KEYS.RETURN_PATH,
    NAVIGATION_STORAGE_KEYS.PROVIDER,
    NAVIGATION_STORAGE_KEYS.CALLBACK_PROCESSED,
    NAVIGATION_STORAGE_KEYS.CALLBACK_TIME
  ];

  keysToRemove.forEach(key => {
    const value = WealthicaStorage.getItem(key);
    if (value) {
      logger.info('Wealthica2NavigationProvider', `[CLEAR-DATA] Removing navigation key: ${key}`, {
        key,
        hasValue: !!value,
        valuePreview: key.includes('STATE') && value ? value.substring(0, 8) + '...' : value,
        timestamp: new Date().toISOString()
      });
    }
  });

  logger.info('Wealthica2NavigationProvider', 'Navigation data clearing completed', {
    clearedKeys: keysToRemove,
    timestamp: new Date().toISOString()
  });

  WealthicaStorage.removeItem(NAVIGATION_STORAGE_KEYS.STATE);
  WealthicaStorage.removeItem(NAVIGATION_STORAGE_KEYS.RETURN_PATH);
  WealthicaStorage.removeItem(NAVIGATION_STORAGE_KEYS.PROVIDER);
  WealthicaStorage.removeItem(NAVIGATION_STORAGE_KEYS.CALLBACK_PROCESSED);
  WealthicaStorage.removeItem(NAVIGATION_STORAGE_KEYS.CALLBACK_TIME);
}

/**
 * Detect page reload loops to mitigate UX traps.
 */
export function detectReloadLoop(): boolean {
  try {
    const reloadCountStr = WealthicaStorage.getItem(NAVIGATION_STORAGE_KEYS.RELOAD_COUNT);
    const reloadCount = reloadCountStr ? parseInt(reloadCountStr, 10) : 0;
    if (reloadCount > 3) {
      logger.warn('Wealthica2NavigationProvider', 'Detected reload loop, might need to clear storage', {
        reloadCount
      });
      WealthicaStorage.removeItem(NAVIGATION_STORAGE_KEYS.RELOAD_COUNT);
      return true;
    }
    WealthicaStorage.setItem(NAVIGATION_STORAGE_KEYS.RELOAD_COUNT, String(reloadCount + 1));
    return false;
  } catch (e) {
    return false;
  }
}
